export default __webpack_public_path__ + "static/media/orangeCalendarToday.b56775db.svg";